import { RecipeVariantProps, sva } from "styled-system/css";

export const selectableImage = sva({
  slots: ["root", "indicator", "icon"],
  base: {
    root: { position: "relative", borderRadius: "full", overflow: "hidden" },
    indicator: {
      backgroundColor: "transparent",
      borderRadius: "full",
      borderColor: "transparent",
      borderWidth: "6px",
      borderStyle: "solid",
      position: "absolute",
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      transition: "all 200ms",
    },
    icon: {
      position: "absolute",
      top: "50%",
      left: "50%",
      transform: "translateX(-50%) translateY(-50%)",
      transition: "all 500ms",
    }
  },
  variants: {
    size: {
      lg: {
        root: {
          height: "60px",
          minHeight: "60px",
          maxHeight: "60px",
          width: "60px",
          minWidth: "60px",
          maxWidth: "60px",
        },
        indicator: {
          borderWidth: "6px",
        },
        icon: {
          width: "32px",
          height: "32px",
        },
      }
    },
    visual: {
      primary: {
        indicator: {
          _hover: {
            borderColor: "border.primary",
            "&:has(input[type=\"checkbox\"]:disabled)": {
              borderColor: "transparent",
            },
          },
          _focusWithin: {
            borderColor: "border.primary",
            "&:has(input[type=\"checkbox\"]:disabled)": {
              borderColor: "transparent",
            },
          },
          "&:has(input[type=\"checkbox\"]:checked)": {
            backgroundColor: "bg.primary.dark",
          }
        },
        icon: {
          color: "icon.inverse",
        },
      },
      accent: {
        indicator: {
          _hover: {
            borderColor: "border.accent.blue",
            "&:has(input[type=\"checkbox\"]:disabled)": {
              borderColor: "transparent",
            },
          },
          _focusWithin: {
            borderColor: "border.accent.blue",
            "&:has(input[type=\"checkbox\"]:disabled)": {
              borderColor: "transparent",
            },
          },
          "&:has(input[type=\"checkbox\"]:checked)": {
            backgroundColor: "bg.accent.blue.dark",
          }
        },
        icon: {
          color: "icon.inverse",
        },
      },
      disabled: {
        indicator: { backgroundColor: "icon.disabled" },
      },
    },
  },
  defaultVariants: {
    size: "lg",
    visual: "accent",
  },
});

export type SelectableImageVariants = RecipeVariantProps<
  typeof selectableImage
>;
